<script setup lang="ts">

import VideoButton from './VideoButton.vue';

type Props =
{
    title?: string,
    videoSrc: string
}

defineProps<Props>();

</script>

<template>

    <div class="flex flex-col items-center justify-center">
        <div v-if="title != null" 
            class="text-2xl font-bold text-center my-6 text-yellow-400">
            {{ title }}
        </div>
        <div class="flex justify-around gap-10">
            <VideoButton :src="videoSrc" title="Watch Video" />
            <slot></slot>
        </div>
    </div>

</template>